var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInEditorMode)?_c('dr-wrapper',_vm._g(_vm._b({},'dr-wrapper',_vm.$props,false),_vm.wrapOn),[_c('drLogin',_vm._b({class:_vm.evaluateClasses(_vm.classes),attrs:{"disabled":true}},'drLogin',_vm.$props,false))],1):_c('drLogin',_vm._b({class:_vm.evaluateClasses(_vm.classes),attrs:{"disabled":false}},'drLogin',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }